// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2nKNm","loaderOuter":"PageOverlayLoader_loaderOuter__2-qKO"};